import React, {useMemo} from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import List from './List';

const Default = () => {

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">
            <KPI
                title="People"
                icon="faPerson"
                dataProviderName={'statistics/total/count/persons/person'}
            />
            <KPI
                title="Active assignments"
                icon="faPeople"
                dataProviderName={'statistics/item/count/cars/pool'}
                filters={{
                    'items': [
                        {
                            'field': 'assignment_start_at',
                            'operator': 'before',
                            'value': new Date().toISOString()
                        },
                        {
                            'field': 'assignment_end_at',
                            'operator': 'after',
                            'value': new Date().toISOString()
                        }
                    ]
                }}
            />
        </Box>
        <List />
    </>,[])

}

export default Default;


